import gsap from 'gsap'

export const initPreloader = () => {
	const preloader = document.querySelector('.preloader')
	
	if (!preloader) return

	return

	const logo = preloader.querySelector('.preloader__logo')

	const tl = gsap.timeline({
		delay: 0.4,
		repeat: -1,
	})

  tl.to(logo, { 
    opacity: 0, 
    yPercent: -10,
		scale: 0.8,
    duration: 0.8,
    ease: "Expo.easeIn"
  })
  
  tl.to(preloader, { 
    duration: 1.6,
		clipPath: 'inset(0 0 100% 0)',
    ease: "expo.out"
  }, "-=0.2")
}

export default () => {}

initPreloader()